import React from "react";
import CustomDialog from "../../components/general/CustomDialog";
import {useTranslation} from "react-i18next";
import {UserInterface} from "../../services/interface/UserInterface";
import ProcessAccess from "./ProcessAccess";

interface Props {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    user?: UserInterface;
}
export default function DialogPermission({open, setOpen, user}: Props) {
    const {t} = useTranslation("global") as { t: (key: string) => string }

    return(
        <CustomDialog
            size={'lg'}
            title={t('permissions')}
            body={
                <div className={'flex flex-col gap-3 min-h-[300px]'}>
                    <ProcessAccess {...{user}}/>
                </div>
            }
            {...{open, setOpen}}
        />
    )
}